module.exports = __webpack_public_path__ + "static/media/activeSort.22833566.svg";